module.exports = __webpack_public_path__ + "075ecb22cc576928705d9d8a823f2e1e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/sofas/sofa-beach.png
// module id = 989
// module chunks = 0